'use client';

import { FunctionComponent } from 'react';
import { BookAside, BookAsideProps } from '../../../../components/BookAside';
import { useOccurrencesWithoutExpiredOffers } from '../../../../hooks/useOccurrencesWithoutExpiredOffers';

export const BookAsideWithoutExpiredOffers: FunctionComponent<BookAsideProps> = ({
    course,
    educator,
    memberships,
    occurrences,
    vouchersAppInstalled,
}) => {
    const occurrencesWithoutExpiredOffers = useOccurrencesWithoutExpiredOffers({ occurrences });

    return (
        <BookAside
            course={course}
            educator={educator}
            occurrences={occurrencesWithoutExpiredOffers}
            memberships={memberships}
            vouchersAppInstalled={vouchersAppInstalled}
        />
    );
};
